import { useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { LanguageCodes } from "@ers/data/";
import { translationsFetched } from "./translator.actions";
import { getTranslations } from "./translator.selectors";

const useTranslator = (langId) => {
	const code = LanguageCodes[langId];
	const translations = useSelector((state) => getTranslations(state, { code }));
	const dispatch = useDispatch();
	const loadTranslations = useCallback(async () => {
		const defaultMessages = await import(
			`./lang/default.js` /* webpackChunkName: "LangPack_Defaults" */
		);
		if (code) {
			try {
				const pack = await import(
					`./lang/${code}.js` /* webpackChunkName: "LangPack_[request]" */
				);
				dispatch(
					translationsFetched(code, {
						...defaultMessages.default,
						...pack.default,
					}),
				);
			} catch (e) {
				dispatch(translationsFetched(code, defaultMessages.default));
			}
		} else {
			dispatch(translationsFetched(code, defaultMessages.default));
		}
	});
	useEffect(() => {
		if (!translations && langId) {
			loadTranslations();
		}
	}, [langId, translations]);
	return translations;
};
export default useTranslator;
